import { useEffect, useState } from "react";
import insightsApi from "../api/insightsApi";

// A project's segments (GET /insights/projects/<id>/segments/), for linking a
// single-choice question to one: [{ id, title, choices: [{ id, label }] }].
// [] with no project, while loading, or when the fetch fails.
export default function useProjectSegments(projectId) {
    const [segments, setSegments] = useState([]);

    useEffect(() => {
        setSegments([]);
        if (!projectId) return undefined;
        let cancelled = false;
        // Started inside the promise chain, so any failure — even a synchronous
        // one — just leaves the list empty instead of crashing the builder.
        Promise.resolve()
            .then(() => insightsApi.getSegments(projectId))
            .then((data) => {
                if (!cancelled) setSegments(Array.isArray(data) ? data : data?.results || []);
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, [projectId]);

    return segments;
}
